__turbopack_context__.v({
  "columnsDropdownContainer": "DropdownStyles-module-scss-module___TJg8G__columnsDropdownContainer",
  "dropdownTitle": "DropdownStyles-module-scss-module___TJg8G__dropdownTitle",
});
